export const WHATSAPP_NUMBER = "+6281290328046";
export const WHATSAPP_LINK = `https://api.whatsapp.com/send?phone=${WHATSAPP_NUMBER.replace(
  "+",
  ""
)}`;
